import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatGoogleCalendarDate = (date: string | dayjs.Dayjs) =>
  dayjs(date).utc().format('YYYYMMDD[T]HHmmss[Z]');

export const getInterviewTypeText = (type: string) => {
  switch (type) {
    case 'Phone':
      return 'Telefon';
    case 'Video':
    case 'Online':
      return 'Online';
    case 'In-Person':
      return 'Yüz Yüze';
    default:
      return type;
  }
};

export const getInterviewStatusText = (status: string) => {
  switch (status) {
    case 'Scheduled':
      return 'Planlandı';
    case 'Completed':
      return 'Tamamlandı';
    case 'Cancelled':
      return 'İptal Edildi';
    case 'Rescheduled':
      return 'Yeniden Planlandı';
    default:
      return status;
  }
};

export const getInterviewStatusColor = (status: string) => {
  switch (status) {
    case 'Scheduled':
      return 'blue';
    case 'Completed':
      return 'green';
    case 'Cancelled':
      return 'red';
    case 'Rescheduled':
      return 'orange';
    default:
      return 'default';
  }
};

export const formatInterviewDate = (date: string, withWeekday = false) =>
  withWeekday
    ? dayjs(date).format('DD MMMM YYYY, dddd, HH:mm')
    : dayjs(date).format('DD.MM.YYYY HH:mm');
